import React from "react";

import "./index.scss";
import {useTranslation} from "react-i18next";

function EmptyData() {
	const {t} = useTranslation();

	return (
		<div className="empty-data-container padding-small">{t("no_data")}</div>
	);
}

export default EmptyData;
